import React, { useRef, useEffect } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";

const student1 = "./Banner/student/shar.png"
const student2 = "./Banner/student/sur.png"
const student3 = "./Banner/student/testimonials-3.png"


const reviews = [
  {
    id: 1,
    text: `"I am Surbhi Hirpara. I have successfully completed my training in PHP with Megascale. 
            I got great technical knowledge from this institute. Thanks to Megascale for this great opportunity."`,
    name: "Surbhi Hirpara",
    college: "J.P. Dawer Institute of Information & Technology",
    semester: "Bsc.IT (6th sem)",
    role: "PHP Web Developer",
    image: [student2],
  },
  {
    id: 2,
    text: `"If i talk about my experiance as a fresher,I always wanted to choose the environment where I can grow and apply all the efforts and skills of mine.In this Institute,I've grasp 
    great knowledge and got chance to grow.I've been always dedicated towards this institute."`,
    name: "shradhdha kukadiya",
    college: "J.P.Dawer institute of information & technology",
    semester: "Bsc.IT(6th sem)",
    role: "PHP Web Developer",
    image: [student1],
  },
  {
    id: 3,
    text: `"Hello, Myself Tanmayi Patel took my training in Web development from Megascale and journey of overall period 
    was fantastic. I got my fundamentals clear. Also I am very thankful to Megascale for giving me good training."`,
    name: "Tanmayi Patel",
    college: "CGPIT,Uka Tarsadia university,Bardoli",
    semester: " B.Tech (7th Semester)",
    role: "Student",
    image: [student3],
  },
];

const ReviewSlider = () => {
  const prevRef = useRef(null);
  const nextRef = useRef(null);
  const swiperRef = useRef(null);

  // Use useEffect to initialize navigation after render
  useEffect(() => {
    if (swiperRef.current) {
      const swiperInstance = swiperRef.current.swiper;
      swiperInstance.navigation.init();
      swiperInstance.navigation.update();
    }
  }, []); // Only run once after the component is mounted

  return (
    <section
      className="relative w-full min-h-[600px] bg-fixed bg-cover bg-center flex items-center justify-center overflow-hidden"
      style={{ backgroundImage: "url('/Banner/background-talk-about-us.jpg')" }}
    >
      {/* Overlay to Darken Background */}
      <div className="absolute inset-0 bg-black bg-opacity-50"></div>

      {/* Swiper Slider */}
      <Swiper
        ref={swiperRef}
        modules={[Navigation, Autoplay]}
        spaceBetween={50}
        slidesPerView={1}
        navigation={{
          prevEl: prevRef.current,
          nextEl: nextRef.current,
        }}
        autoplay={{ delay: 5000, disableOnInteraction: false }}
        className="relative z-10 w-full max-w-4xl px-4"
      >
        {reviews.map((review) => (
          <SwiperSlide key={review.id}>
            <div className="flex flex-col items-center">
              {/* Glassmorphism Review Box */}
              <div className="bg-white bg-opacity-20 backdrop-blur-sm text-white p-8 rounded-lg text-center shadow-lg max-w-2xl">
                <p className="text-lg">{review.text}</p>
                <div className="mt-4 text-left">
                  <p className="font-semibold">Name: {review.name}</p>
                  <p className="text-sm">College: {review.college}</p>
                  <p className="text-sm">Semester: {review.semester}</p>
                </div>
              </div>

              {/* Reviewer Profile */}
              <div className="flex flex-col items-center mt-4">
                <div className="w-0 h-0 border-l-8 border-r-8 border-b-8 border-transparent border-b-white"></div> {/* Arrow */}
                <img
                  src={review.image}
                  alt={review.name}
                  className="w-24 h-24 rounded-full border-4 border-white mt-2"
                />
                <h3 className="text-blue-500 font-bold mt-2">{review.name}</h3>
                <p className="text-white text-sm">{review.role}</p>
              </div>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>

      {/* Custom Navigation Arrows */}
      <div
        ref={prevRef}
        className="absolute top-1/2 left-5 transform -translate-y-1/2 z-20 cursor-pointer text-white text-3xl hover:scale-110 transition"
      >
        ❮
      </div>
      <div
        ref={nextRef}
        className="absolute top-1/2 right-5 transform -translate-y-1/2 z-20 cursor-pointer text-white text-3xl hover:scale-110 transition"
      >
        ❯
      </div>
    </section>
  );
};

export default ReviewSlider;
  